import { Input } from "antd";
import PropTypes from "prop-types";

import classnames from "classnames";
import Label from "../Label";

const Email = ({
  label,
  placeholder,
  errors,
  touched,
  icon,
  innerRef,
  required,
  direction,
  optional,
  ...rest
}) => {
  return (
    <div
      className={classnames(
        "acoris__input",
        { "acoris__input--error": touched && errors },
        { "acoris__input--valid": touched && !errors },
        direction,
      )}
    >
      <Label
        label={label}
        icon={icon}
        required={required}
        optional={optional}
      />
      <div className="acoris__input--field">
        <Input
          type="email"
          className={classnames({
            "disable--input": rest.disabled,
          })}
          placeholder={placeholder}
          ref={innerRef}
          {...rest}
        />
        {touched && errors && <p className="input--errors">{errors}</p>}
      </div>
    </div>
  );
};

Email.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

Email.defaultProps = {
  label: "",
  placeholder: "",
};
export default Email;
